<template>
    <v-container mb-12>
        <v-row>
            <!-- Reset Password Image -->
            <v-col
                cols="12"
                sm="6"
            >
                <div
                    class="d-flex fill-height align-center justify-center"
                >
                    <v-img
                        max-width="80%"
                        :src="require('../../assets/unlock.svg')"
                    />
                </div>
            </v-col>
            <!-- Reset Password Header and Form -->
            <v-col>
                <v-form
                    ref="form"
                    @submit.prevent="onSubmit"
                >
                    <v-row justify="center">
                        <v-col
                            cols="12"
                            lg="8"
                        >
                            <h1 class="display-2 mb-2">
                                Password Reset
                            </h1>
                        </v-col>
                        <v-col
                            cols="12"
                            lg="8"
                        >
                            <v-text-field
                                label="New Password"
                                v-model="password"
                                validate-on-blur
                                :rules="[
                                    rules.required,
                                    rules.noSpaces,
                                    rules.length
                                ]"
                                :hint="passwordHint"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                @click:append="showPassword = !showPassword"
                                color="secondary"
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            lg="8"
                        >
                            <v-text-field
                                label="Confirm New Password"
                                v-model="confirmPassword"
                                validate-on-blur
                                :rules="[
                                    rules.confirmPassword
                                ]"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                @click:append="showPassword = !showPassword"
                                color="secondary"
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            lg="8"
                        >
                            <div class="d-flex">
                                <v-spacer />
                                <v-btn
                                    type="submit"
                                    :loading="isSubmitting"
                                    :disabled="isSubmitting"
                                    color="primary"
                                    block
                                    large
                                >
                                    Submit
                                </v-btn>
                            </div>
                        </v-col>

                        <v-col cols="12" class="text-center">
                            Back to <router-link :to="{name: 'login'}">Login</router-link>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'
import jwtDecode from 'jwt-decode'
import {
    requiredValidation,
    noSpacesValidation,
    minPasswordLengthValidation
} from '../../utils/validations'
import MessageBus from '../../utils/buses/MessageBus'
import { default422Error, defaultError } from '../../utils/constants/errors'
import { passwordHint } from '../../utils/constants/hints'

export default {
    data () {
        return {
            token: this.$route.query.t,
            password: null,
            confirmPassword: null,
            showPassword: false,
            isSubmitting: false,
            rules: {
                required: requiredValidation,
                noSpaces: noSpacesValidation,
                length: minPasswordLengthValidation,
                confirmPassword: value => value === this.password || 'Passwords do not match'
            },
            passwordHint
        }
    },
    // must be mounted so MessageBus can show a message on app load
    mounted () {
        // decode jwt
        try {
            const decoded = jwtDecode(this.token)

            const expire = decoded.exp
            const now = (new Date().getTime() / 1000)
            // throw error if token is expired
            if (now > expire) {
                MessageBus.sendMessage('Your token has expired. Please request a new password reset', 'error')
            }
        } catch (err) {
            MessageBus.sendMessage('There was an error processing the password reset token. Please request a new password reset', 'error')
        }
    },

    methods: {
        onSubmit () {
            if (!this.$refs.form.validate()) {
                MessageBus.sendMessage(default422Error, 'error')
                return
            }

            this.isSubmitting = true
            axios.put('/reset-password', {
                token: this.token,
                password: this.password
            })
                .then(res => {
                    MessageBus.sendMessage('Succesffuly Reset Password', 'success')
                    this.$router.push({ name: 'login' })
                })
                .catch(err => {
                    console.error('Error resetting password', err)
                    MessageBus.sendMessage(defaultError, 'error')
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        }

    }
}
</script>
